<ng-container *ngIf="data">
  <span>
    {{ data.url }}
  </span>
  <mat-icon color="primary" (click)="copy()">content_copy</mat-icon>
</ng-container>
